import React, { useState } from 'react';
import {
  Sheet,
  SheetContent,
} from '../ui/sheet';

// Clean cropped guide images - just t-shirt with print area
const GUIDE_IMAGES = {
  front: 'https://customer-assets.emergentagent.com/job_f32eb51c-8252-4780-8518-16f19df1a9f8/artifacts/9hufcugi_Skjermbilde%202026-03-13%20kl.%2022.09.58.png',
  back: 'https://customer-assets.emergentagent.com/job_f32eb51c-8252-4780-8518-16f19df1a9f8/artifacts/tj0d78jg_Skjermbilde%202026-03-13%20kl.%2022.08.32.png',
  left: 'https://customer-assets.emergentagent.com/job_f32eb51c-8252-4780-8518-16f19df1a9f8/artifacts/c24xg3af_Skjermbilde%202026-03-13%20kl.%2022.08.41.png',
  right: 'https://customer-assets.emergentagent.com/job_f32eb51c-8252-4780-8518-16f19df1a9f8/artifacts/c24xg3af_Skjermbilde%202026-03-13%20kl.%2022.08.41.png',
};

const VIEW_ORDER = ['front', 'back', 'left', 'right'];
const VIEW_LABELS = { front: 'Front', back: 'Back', left: 'Sleeves', right: 'Sleeves' };

export const PrintGuidePanel = ({ isOpen, onClose, currentView }) => {
  const [selectedGuide, setSelectedGuide] = useState(currentView);
  
  React.useEffect(() => {
    if (isOpen) {
      setSelectedGuide(currentView);
    }
  }, [isOpen, currentView]);

  // For sleeves, both left and right use the same image
  const effectiveGuide = (selectedGuide === 'left' || selectedGuide === 'right') ? 'left' : selectedGuide;
  const imageUrl = GUIDE_IMAGES[effectiveGuide];
  const title = selectedGuide === 'front' ? 'Front' : selectedGuide === 'back' ? 'Back' : 'Sleeves';

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent 
        side="left" 
        className="w-[320px] sm:w-[380px] bg-white border-gray-200 p-0 flex flex-col"
        data-testid="print-guide-panel"
      >
        {/* Tabs - Front, Back, Sleeves */}
        <div className="p-3 border-b border-gray-200">
          <div className="flex gap-2">
            {['front', 'back', 'left'].map((key) => (
              <button
                key={key}
                onClick={() => setSelectedGuide(key)}
                className={`flex-1 py-2.5 px-3 rounded-lg text-sm font-semibold transition-all ${
                  (selectedGuide === key || (key === 'left' && selectedGuide === 'right'))
                    ? 'bg-indigo-500 text-white shadow-md' 
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
                data-testid={`guide-tab-${key}`}
              >
                {VIEW_LABELS[key]}
              </button>
            ))}
          </div>
        </div>

        {/* Title */}
        <div className="px-4 py-3 border-b border-gray-100">
          <h3 className="text-lg font-bold text-gray-800">{title} Print Area</h3>
        </div>

        {/* Image - Takes up full space */}
        <div className="flex-1 flex items-center justify-center p-4 bg-gray-50">
          <img
            src={imageUrl}
            alt="Print area guide"
            className="max-w-full max-h-full object-contain"
            data-testid="print-guide-image"
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default PrintGuidePanel;
